import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderLcAwaitApprov = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();



const [tblsessionvars, setTblsessionvars] = useState([]);


const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	txt:''
	});


const location = useLocation();


useEffect(() => {

const AD_USER=sessionStorage.getItem("AD_USER")??"";

if (AD_USER==""){
	navigate("/");
	return;
	}//end if

if (tblsessionvars.length<1){
	gettblsessionvars();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	
 },[JSON.stringify(tblsessionvars)]);



useEffect(() => {
		gettblsessionvars();
 },[searchcrit]);

function searchcritChange(e){
	
	const {name, value}=e.target;
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

async function gettblsessionvars(){

let arrvar=[], arrval=[];
for (var i = 0; i < sessionStorage.length; i++){
	const key=sessionStorage.key(i);
	arrvar.push(key);
	arrval.push(sessionStorage.getItem(key));
	}//end for

const params = {
crit: searchcrit.txt
, USERNAME: sessionStorage.getItem("USERNAME")
, arrvar: arrvar
, arrval: arrval
};

console.log("gettblsessionvars: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblsessionvars([]);
  await fetch(resturl+'rarwpform/gettblsessionvarlog',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblsessionvars(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblsessionvars(res){
	
if (!res.length)
	return;
	
console.log('aftergettblsessionvars, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	const USERNAME=col['USERNAME'];
	const trkey='tr_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='left' >{col['SVAR']}</td>
	<td align='left' >{col['VALU']}</td>
	<td align='center' >{col['STAMP']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});

setTblsessionvars(htmrows);
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func




  return (
    <>
	
	
<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Session Variables</p>	
	
	
	<table align='center' className='customers' style={{width:"55%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Session Var</th>
		<th>Value</th>
		<th>Date</th>
	</tr>
	</thead>
	<tbody>
		{tblsessionvars}
	</tbody>
	</table>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderLcAwaitApprov;